/**
 * @fileoverview Página 404 (rota não encontrada).
 *
 * Captura o erro no Sentry para rastreamento de rotas
 * inexistentes e exibe mensagem amigável ao usuário.
 */
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { captureError } from "@/lib/sentry";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    captureError(new Error(`404: ${location.pathname}`), { route: location.pathname });
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
